import { CartOrigin } from '@/types/enums/analytics/cart/cart-analytics.enum';

const ENTITY_PROFILE_ROOTS = ['profissionais', 'parceiros', 'laboratorios'];

function isEntityProfile(pathname: string): boolean {
  const segments = pathname.split('/').filter(Boolean);

  return segments.length === 2 && ENTITY_PROFILE_ROOTS.includes(segments[0]);
}

export function getCartOrigin(pathname: string | null | undefined): CartOrigin {
  if (!pathname) {
    return CartOrigin.OTHER;
  }

  if (pathname.startsWith('/busca/')) {
    return CartOrigin.SEARCH_RESULTS;
  }

  if (isEntityProfile(pathname)) {
    return CartOrigin.PROFILE;
  }

  if (pathname.startsWith('/agendamentos')) {
    return CartOrigin.APPOINTMENTS;
  }

  if (pathname === '/' || pathname.startsWith('/cidades/')) {
    return CartOrigin.HOME;
  }

  return CartOrigin.OTHER;
}
